import { render, staticRenderFns } from "./OrderDataPatient.vue?vue&type=template&id=48ec5da4&scoped=true"
import script from "./OrderDataPatient.vue?vue&type=script&lang=js"
export * from "./OrderDataPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec5da4",
  null
  
)

export default component.exports